export default __webpack_public_path__ + "4a2a75569333c33e6aaf1cb21c9d2101.png";